import { Operation } from 'components/organisms/tasks/filters/operations';
import { TextFieldFilterOperationType } from 'components/organisms/tasks/filters/text';
import { unreachable } from '../../unreachable';
const toApiFormat = (filter)=>{
    switch(filter.type){
        case TextFieldFilterOperationType.IsEmpty:
            return {
                operation: Operation.IsEmpty,
                sourceType: filter.field.sourceType
            };
        case TextFieldFilterOperationType.IsNotEmpty:
            return {
                operation: Operation.IsNotEmpty,
                sourceType: filter.field.sourceType
            };
        case TextFieldFilterOperationType.Contains:
            return {
                operation: Operation.Contains,
                value: filter.value,
                sourceType: filter.field.sourceType
            };
        case TextFieldFilterOperationType.DoesNotContain:
            return {
                operation: Operation.NotContains,
                value: filter.value,
                sourceType: filter.field.sourceType
            };
        case TextFieldFilterOperationType.IsExactly:
            return {
                operation: Operation.Value,
                value: filter.value,
                sourceType: filter.field.sourceType
            };
        case TextFieldFilterOperationType.IsNotExactly:
            return {
                operation: Operation.IsNot,
                value: filter.value,
                sourceType: filter.field.sourceType
            };
        default:
            return unreachable(filter);
    }
};
const toType = (operation)=>{
    switch(operation){
        case Operation.IsEmpty:
            return TextFieldFilterOperationType.IsEmpty;
        case Operation.IsNotEmpty:
            return TextFieldFilterOperationType.IsNotEmpty;
        case Operation.Contains:
            return TextFieldFilterOperationType.Contains;
        case Operation.NotContains:
            return TextFieldFilterOperationType.DoesNotContain;
        case Operation.Value:
            return TextFieldFilterOperationType.IsExactly;
        case Operation.IsNot:
            return TextFieldFilterOperationType.IsNotExactly;
        case Operation.NoneOf:
        case Operation.OneOf:
        case Operation.HasValue:
        case Operation.IsNull:
        default:
            return unreachable(operation);
    }
};
const parse = ({ operation, value }, field)=>{
    const type = toType(operation);
    switch(type){
        case TextFieldFilterOperationType.IsEmpty:
        case TextFieldFilterOperationType.IsNotEmpty:
            return {
                field,
                type
            };
        case TextFieldFilterOperationType.Contains:
        case TextFieldFilterOperationType.DoesNotContain:
        case TextFieldFilterOperationType.IsExactly:
        case TextFieldFilterOperationType.IsNotExactly:
            {
                // Values arrive here already decoded — the outer criteria blob has been
                // JSON.parse'd once, so `value` is a plain string. Attempt the legacy
                // JSON-string decode first (for any historical URL that relied on it),
                // and fall back to the raw value when the synthetic JSON is malformed
                // (e.g. the value contains a literal `"`, `\`, or control char). The old
                // hard-fail behaviour silently dropped the whole filter — see the parent
                // `tryParseNativeFieldFilter` catch block.
                let string = null;
                if (value) {
                    try {
                        string = JSON.parse(`"${value}"`);
                    } catch (unused) {
                        string = value;
                    }
                }
                return {
                    field,
                    type,
                    value: string == null ? undefined : string
                };
            }
        default:
            return unreachable(type);
    }
};
export const TextFilter = {
    toApiFormat,
    parse
};
